export default __webpack_public_path__ + "static/media/creditcard-launch-tilted.d32b3685.svg";